<template>
  <div class="backgroundDetail">
    <el-card>
      <div class="jump-btn">
        <!-- 关闭工单 -->
        <el-button v-if="isClose === 1 && form.state < 5" class="btn_orange" @click="closeMaintain()">
          {{$t('lang.btn_closeMaintain')}}</el-button>
        <!-- 查看子工单 -->
        <el-button v-if="haveChild == 1" @click="viewChildWorkOrder" type="primary">查看子工单</el-button>
        <!-- 审阅工单-->
        <el-button v-if="form.state !=1 && review == 1" type="primary" @click="checkMaintains()">{{$t('lang.btn_checkMaintains')}}
        </el-button>
        <!-- 回访工单 -->
        <el-button v-if="form.state === 4" type="primary" @click="followMaintainsres()">
          {{$t('lang.btn_followMaintainsres')}}</el-button>
        <!-- 跟进工单 -->
        <el-button v-if="form.state < 4 && form.state> 1" type="primary" @click="followMaintains()">
          {{$t('lang.btn_followMaintains')}}</el-button>
        <!-- 延时工单 -->
        <el-button v-if="form.state === 2 && form.staffId == userDataid" type="primary" @click="normalMaintains()">{{$t('lang.btn_normalMaintains')}}
        </el-button>
        <!-- 转移工单 -->
        <el-button v-if="form.state === 2 && form.staffId == userDataid" class="btn_orange" @click="cancelMaintains()">
          {{$t('lang.btn_backgroundSupplycancelMaintains')}}</el-button>
        <!-- 变更报事类型  -->
        <el-button type="primary" @click="updateTypeMaintains()">{{$t('lang.btn_backgroundSupplychangetype')}}
        </el-button>
        <el-button type="primary" @click="csjl()">抽审记录
        </el-button>
        <!-- 电梯维保单 -->
        <el-button type="primary" v-if="this.form.maintainTypeId2 == 155 && this.form.quartzJobId > 0 && (this.form.state == 3 || this.form.state == 4)" @click="pdfPrint()">电梯维保单</el-button>
        <el-button type="primary" @click="jump()">返回</el-button>
      </div>
      <!-- 报事用户信息 -->
      <el-form ref="form" :model="form" :label-width="require('@/config/enum').c_w8"
        :label-suffix="require('@/config/enum').c_colon">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('lang.lab_backgroundusername')">
              <span v-if="this.form.user != null">{{ this.form.user.nickName|valueIsNull }}</span>
              <span v-else>{{ this.form.username |valueIsNull }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('lang.lab_backgroundmobile')">
              <span v-if="this.form.user != null">{{this.form.user.mobile |valueIsNull}}</span>
              <span v-else>{{this.form.mobile |valueIsNull}}</span>
            </el-form-item>
            
          </el-col>
        </el-row>
        <el-row>
		  <el-col :span="12">
		    <el-form-item label="报事用户(手录)">
		      <span v-if="this.form.username != null">{{ this.form.username|valueIsNull }}</span>
		    </el-form-item>
		  </el-col>
          <!-- 小区 -->
          <el-col :span="12" v-if="this.form.garden">
            <el-form-item :label="$t('lang.lab_backgroundgarden')">
              <span v-if="this.form.garden!= null">{{ this.form.garden.name |valueIsNull }}</span>
              <span v-else>---</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
		  <!-- 楼号 -->
		  <el-col :span="12" v-if="this.form.garden">
			<el-form-item :label="$t('lang.lab_backgroundhouseName')">
				<span v-if="this.form.garden.grids!= null">{{this.form.garden.grids.houseName |valueIsNull}}</span>
				<span v-else>---</span>
			</el-form-item>
		  </el-col>
          <!-- 单元号 -->
          <el-col :span="12" v-if="this.form.garden">
            <el-form-item :label="$t('lang.lab_backgroundunitName')">
              <span v-if="this.form.garden.grids!= null">{{this.form.garden.grids.unitName |valueIsNull}}</span>
              <span v-else>---</span>
            </el-form-item>
          </el-col>
          
        </el-row>
        <el-row>
		  <!-- 房间号 -->
		  <el-col :span="12" v-if="this.form.garden">
		    <el-form-item :label="$t('lang.lab_backgroundroomName')">
		      <span v-if="this.form.garden.grids!= null">{{this.form.garden.grids.roomName |valueIsNull}}</span>
		      <span v-else>---</span>
		    </el-form-item>
		  </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('lang.lab_backgroundid')">
              <span>{{ this.form.id |valueIsNull }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
		  <el-col :span="12">
		    <el-form-item :label="$t('lang.lab_backgroundMaintainType1Name')">
		      <span>{{ this.form.MaintainType1Name |valueIsNull }}</span>
		    </el-form-item>
		  </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('lang.lab_backgroundty')">
              <!-- 投诉 -->
              <span v-if="this.form.complainFlag ===2">{{$t('lang.lab_paperecomplaint')}}</span>
              <!-- 表扬 -->
              <span v-else-if="this.form.complainFlag ===3">{{$t('lang.lab_paperecommend')}}</span>
              <span v-else>---</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
		  <el-col :span="12">
		    <el-form-item :label="$t('lang.lab_backgroundtypesj')">
		      <span>{{ this.form.maintainOptionCode |valueIsNull }}</span>
		    </el-form-item>
		  </el-col>
          <el-col :span="12">
            <!-- <el-form-item
              v-if="this.form.content&&this.form.content.length> require('@/config/enum').tableDatamaxlength"
              :label="$t('lang.lab_backgroundcontent')"
              :title="this.form.content"
            >
              {{ this.form.content.substring(0, require('@/config/enum').tableDatamaxlength) }}
              <span
                v-if="this.form.content.length>require('@/config/enum').tableDatamaxlength"
              >...</span>
            </el-form-item> -->
            <el-form-item :label="$t('lang.lab_backgroundcontent')">
              {{this.form.content |valueIsNull}}
            </el-form-item>
          </el-col>
        </el-row>
		<el-row>
			<el-col :span="12">
			  <el-form-item label="结束时间">
				{{this.form.endDate | time}}
			  </el-form-item>
			</el-col>
			<el-col :span="12">
			  <el-form-item label="代客报事">
				{{this.form.isValet>0?'是':'否'}}
			  </el-form-item>
			</el-col>
		</el-row>
      </el-form>
      <el-divider></el-divider>
      <!-- 图片 -->
      <el-form ref="form" :model="form" :label-width="require('@/config/enum').c_w8"
        :label-suffix="require('@/config/enum').c_colon">
        <el-row class="matop">
          <el-col :span="24">
            <el-form-item :label="$t('lang.lab_backgroundfilesBefore')" v-if="this.form.filesBefore != null">
              <viewer :images="this.form.filesBefore">
                <img v-for="(src,index) in this.form.filesBefore" :src="src.uri" :key="index" class="img" />
              </viewer>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('lang.lab_backgroundfilesAfter')" v-if="this.form.filesAfter != null">
              <viewer :images="this.form.filesAfter">
                <img v-for="(src,index) in this.form.filesAfter" :src="src.uri" :key="index" class="img" />
              </viewer>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 处理前附件 -->
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('lang.lab_backgroundwithFilesBefore')">
              <a class="btnmar" v-for="(src,index) in this.form.withFilesBefore" @click="handlePreview(src.uriNew)"
                :key="index" download>{{src.uriNew.split('|')[1]}}</a>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 处理后附件 -->
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('lang.lab_backgroundwithFilesAfter')">
              <a class="btnmar" v-for="(src,index) in this.form.withFilesAfter" @click="handlePreview(src.uriNew)"
                :key="index" download>{{src.uriNew.split('|')[1]}}</a>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 跟进回访图片 -->
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('lang.lab_backgroundfilesFollow')" v-if="this.form.filesFollow != null">
              <viewer :images="this.form.filesFollow">
                <img v-for="(src,index) in this.form.filesFollow" :src="src.uri" :key="index" class="img" />
              </viewer>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 跟进回访附件 -->
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('lang.lab_backgroundwithFilesFollow')">
              <a class="btnmar" v-for="(src,index) in this.form.withFilesFollow" @click="handlePreview(src.uriNew)"
                :key="index" download>{{src.uriNew.split('|')[1]}}</a>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 延时图片 -->
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('lang.lab_backgroundfilesNormal')" v-if="this.form.filesNormal != null">
              <viewer :images="this.form.filesNormal">
                <img v-for="(src,index) in this.form.filesNormal" :src="src.uri" :key="index" class="img" />
              </viewer>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="签到图片" v-if="this.form.filesQd != null">
              <viewer :images="this.form.filesQd">
                <img v-for="(src,index) in this.form.filesQd" :src="src.uri" :key="index" class="img" />
              </viewer>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row class="matop">
          <el-col :span="8">
            <!-- 报事一级分类 -->
            <el-form-item :label="$t('lang.lab_backgroundmaintainType1')">
              <span v-if="this.form.maintainType1!=null">{{this.form.maintainType1.name | valueIsNull}}</span>
              <span v-else>---</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <!-- 报事二级分类 -->
            <el-form-item :label="$t('lang.lab_backgroundmaintainType2')">
              <span v-if="this.form.maintainType2!=null">{{this.form.maintainType2.name | valueIsNull}}</span>
              <span v-else>---</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <!-- 报事三级分类 -->
            <el-form-item :label="$t('lang.lab_backgroundmaintainType3' )">
              <span v-if="this.form.maintainType3!=null">{{this.form.maintainType3.name | valueIsNull}}</span>
              <span v-else>---</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <!-- 报事四级分类 -->
            <el-form-item :label="$t('lang.lab_backgroundmaintainType4' )">
              <span v-if="this.form.maintainType4!=null">{{this.form.maintainType4.name | valueIsNull}}</span>
              <span v-else>---</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <!-- 报事五级分类 -->
            <el-form-item :label="$t('lang.lab_backgroundmaintainType5' )">
              <span v-if="this.form.maintainType5!=null">{{this.form.maintainType5.name | valueIsNull}}</span>
              <span v-else>---</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <!-- 工单状态 -->
            <el-form-item :label="$t('lang.lab_backgroundstate')">
              <span>
                <!-- 报事状态 -->
                <span v-if="this.form.state === 0">{{$t('lang.lab_paperereportingstate')}}</span>
                <!-- 待确认 -->
                <span v-if="this.form.state === 1">{{$t('lang.lab_papereconfirmed')}}</span>
                <!-- 处理中 -->
                <span v-if="this.form.state === 2">{{$t('lang.lab_paperesolved')}}</span>
                <!-- 已完成 -->
                <span v-if="this.form.state === 3">{{$t('lang.lab_paperefinsh')}}</span>
                <!-- 已评价 -->
                <span v-if="this.form.state === 4">{{$t('lang.lab_paperealreadyevaluated')}}</span>
                <!-- 正常关闭 -->
                <span v-if="this.form.state === 5">{{$t('lang.lab_paperecloses')}}</span>
                <!-- 非正常关闭 -->
                <span v-if="this.form.state === 6">{{$t('lang.lab_paperenoclose')}}</span>
                <!-- 7: 已撤销 -->
                <span v-if="this.form.state === 7">{{$t('lang.lab_fileCancel')}}</span>
                <!-- 8: 已关闭（挂起） -->
                <span v-if="this.form.state === 8">已关闭（挂起）</span>
                <!-- —待处理 -->
                <i v-if="this.form.state === 2" class="normals">{{$t('lang.lab_paperesolveds')}}</i>
                <!-- —待评价 -->
                <i v-if="this.form.state === 3" class="normals">{{$t('lang.lab_paperealreadyevaluateds')}}</i>
                <!-- —已评价 -->
                <i v-if="this.form.state === 4" class="normals">{{$t('lang.lab_alerypaperealreadyevaluateds')}}</i>
              </span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <!-- 工单类型 -->
            <el-form-item :label="$t('lang.lab_backgroundnormal')">
              <!-- 正常工单 -->
              <span v-if="this.form.normal === 0">{{$t('lang.lab_normalLift')}}</span>
              <!-- 延时工单 -->
              <span v-if="this.form.normal === 1">{{$t('lang.lab_outlLift')}}</span>
              <!-- 正常工单 -->
              <span v-if="this.form.normal === 2">{{$t('lang.lab_normalLift')}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <!-- 工单难易评价 -->
            <el-form-item :label="$t('lang.lab_backgrounddifficulty')">
              <span v-if="this.form.difficulty === 1">{{$t('lang.NewspaperInfoDetail.evaluationlist[0].name')}}</span>
              <span
                v-else-if="this.form.difficulty === 2">{{$t('lang.NewspaperInfoDetail.evaluationlist[1].name')}}</span>
              <span
                v-else-if="this.form.difficulty === 3">{{$t('lang.NewspaperInfoDetail.evaluationlist[2].name')}}</span>
              <span
                v-else-if="this.form.difficulty === 4">{{$t('lang.NewspaperInfoDetail.evaluationlist[3].name')}}</span>
              <span
                v-else-if="this.form.difficulty === 5">{{$t('lang.NewspaperInfoDetail.evaluationlist[4].name')}}</span>
              <span v-else>---</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-divider></el-divider>
      <el-form ref="form" :model="form" class="form" :label-width="require('@/config/enum').c_w8"
        :label-suffix="require('@/config/enum').c_colon">
        <el-row class="matop">
          <el-col :span="8">
            <!-- 接单人员 -->
            <el-form-item :label="$t('lang.lab_backgroundstaffId')">
              <span v-if="this.form.staffId != 0&&this.form.staff!= null">{{this.form.staff.idNo | valueIsNull}}</span>
              <span v-else>---</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <!-- 处理人员 -->
            <el-form-item :label="$t('lang.lab_backgroundcheckerName')">{{this.form.checkerName | valueIsNull}}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <!-- 抄送人员 -->
            <el-form-item label="抄送人员">{{this.form.maintainCopyToStaff | valueIsNull}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <!-- 评价等级 选择评价 评价内容 图片评价 -->
        <!-- 评价等级 -->
        <el-row v-if="form.evaluateDetailList&&form.evaluateDetailList.length>0">
          <el-col :span="24">
            <el-form-item :label="$t('lang.lab_rating')">
              <!-- 好评 -->
              <span v-if="this.form.evaluateDetailList[0].oneEvaluation===1">{{$t('lang.lab_praise')}}</span>
              <!-- 中评 -->
              <span v-if="this.form.evaluateDetailList[0].oneEvaluation===2">{{$t('lang.lab_average')}}</span>
              <!-- 差评 -->
              <span v-if="this.form.evaluateDetailList[0].oneEvaluation===3">{{$t('lang.lab_bad')}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 选择评价 -->
        <el-row v-if="form.evaluateDetailList&&form.evaluateDetailList.length>0">
          <el-col :span="24">
            <el-form-item :label="$t('lang.lab_backgroundtwoEvaluation')">
              <span
                v-if="this.form.evaluateDetailList[0].twoEvaluation">{{this.form.evaluateDetailList[0].twoEvaluation}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 评价内容 -->
        <el-row v-if="form.evaluateDetailList&&form.evaluateDetailList.length>0">
          <el-col :span="24">
            <el-form-item :label="$t('lang.lab_backgroundthreeEvaluation')">
              <span
                v-if="this.form.evaluateDetailList[0].threeEvaluation">{{this.form.evaluateDetailList[0].threeEvaluation}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 图片评价 -->
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('lang.lab_backgrounduri')">
              <viewer :images="this.form.filesEvaluate">
                <img v-for="(src,index) in this.form.filesEvaluate" :src="src.uri" :key="index" class="img" />
              </viewer>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row class="matop">
          <el-col :span="8">
            <!-- 审阅状态 -->
            <el-form-item :label="$t('lang.lab_backgroundisCheck')">
              <!-- 未审阅 -->
              <span v-if="this.form.isCheck === 0">{{$t('lang.lab_notreviewed')}}</span>
              <!-- 合格 -->
              <span v-else-if="this.form.isCheck === 1">{{$t('lang.lab_qualified')}}</span>
              <!-- 不合格 -->
              <span v-else-if="this.form.isCheck === 2">{{$t('lang.lab_noqualified')}}</span>
              <span v-else>---</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <!-- 审阅图片 -->
            <el-form-item :label="$t('lang.lab_backgroundfilesCheck')">
              <viewer :images="this.form.filesCheck">
                <img v-for="(src,index) in this.form.filesCheck" :src="src.uri" :key="index" class="img" />
              </viewer>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <!-- 审阅备注 -->
            <el-form-item
              v-if="this.form.checkInfo&&this.form.checkInfo.length> require('@/config/enum').tableDatamaxlength"
              :label="$t('lang.lab_backgroundcheckInfo')" :title="this.form.checkInfo">
              {{ this.form.checkInfo.substring(0, require('@/config/enum').tableDatamaxlength) }}
              <span v-if="this.form.checkInfo.length>require('@/config/enum').tableDatamaxlength">...</span>
            </el-form-item>
            <el-form-item v-else :label="$t('lang.lab_backgroundcheckInfo')">{{this.form.checkInfo |valueIsNull}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('lang.lab_backgroundfilesCancel')">
              <a class="btnmar" :href="src.uri" v-for="(src,index) in this.form.maintainFilesCancel" :key="index"
                download>{{$t('lang.btn_withfiles')}}</a>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <!-- 工单一生 -->
        <el-form-item :label="$t('lang.lab_backgroundleft')">
          <el-table :data="tableData" class="wid80" :row-class-name="tableRowClassName">
            <el-table-column prop="createtime" :label="$t('lang.lab_backgroundtime')">
              <template slot-scope="scope">{{ scope.row.createtime | time }}</template>
            </el-table-column>
            <el-table-column prop="action" :label="$t('lang.lab_backgroundnat')"></el-table-column>
            <el-table-column :label="$t('lang.lab_backgroundtext')" width="850px">
              <template slot-scope="scope">
                <div>
                  <font color="#c69c6d">
                    {{scope.row.content1}}：
                    <strong>{{scope.row.content2.replace('null', "")}}</strong>
                  </font>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="电子签名">
              <template slot-scope="scope">
                <viewer class="img-width" v-if="scope.row.digitalSignature!=null&&scope.row.digitalSignature.length>0">
                  <img :src="scope.row.digitalSignature" class="img">
                </viewer>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <el-divider></el-divider>
      <!-- 巡检路线 目前没看见有数据情况 -->
      <el-form v-if="showPL" :model="formpl" :label-width="require('@/config/enum').c_w8"
        :label-suffix="require('@/config/enum').c_colon">
        <el-form-item :label="$t('lang.lab_route')">
          <el-button @click="updatePatrolPointLineId(maintainPatrolPointLine[0].patrolPointLine)"
            v-if="this.maintainPatrolPointLine.length>0">{{maintainPatrolPointLine[0].patrolPointLineName}}</el-button>
          &emsp;{{$t('lang.lab_notreviewed')}}{{this.jindu}}
        </el-form-item>
        <el-form-item :label="$t('lang.lab_PL')">
          <el-table :data="maintainPatrolPointLine" class="wid80" :row-class-name="tableRowClassName">
            <el-table-column prop="createtime" :label="$t('lang.lab_PL_time')">
              <template slot-scope="scope">{{ scope.row.createTime | time }}</template>
            </el-table-column>
            <el-table-column prop="pointName" :label="$t('lang.lab_PL_pointName')">
              <template slot-scope="scope">
                <el-button @click="updatePatrolPointId(scope.row)">{{scope.row.pointName}}</el-button>
              </template>
            </el-table-column>
            <el-table-column :label="$t('lang.lab_PL_state')">
              <template slot-scope="scope">
                <span v-if="scope.row.state===0">{{$t('lang.lab_nofinish')}} ：{{scope.row.info}}</span>
                <span v-else-if="scope.row.state===1">{{$t('lang.lab_aleryfinish')}} ：{{scope.row.info}}</span>
                <span v-else>{{$t('lang.lab_unfinishs')}} ：{{scope.row.info}}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-divider></el-divider>
      </el-form>
      <!-- 巡检标准进度 列表-->
      <el-form v-if="show" :model="formbzs" :label-width="require('@/config/enum').c_w8"
        :label-suffix="require('@/config/enum').c_colon">
        <el-form-item :label="$t('lang.lab_Patrol')">
          <span>{{$t('lang.lab_allStateCount')}}:{{maintainPatrol[0].allStateCount}}</span>
          <span class="pad-lef20">{{$t('lang.lab_finishStateCount')}}:{{maintainPatrol[0].finishStateCount}}</span>
          <span class="pad-lef20">{{$t('lang.lab_errorStateCount')}}:{{maintainPatrol[0].errorStateCount}}</span>
          <span class="pad-lef20">{{$t('lang.lab_undoneStateCount')}}:{{maintainPatrol[0].undoneStateCount}}</span>
          <span class="pad-lef20">{{$t('lang.lab_missStateCount')}}:{{maintainPatrol[0].missStateCount}}</span>
        </el-form-item>
        <el-form-item label>
          <el-table :data="maintainPatrol" class="wid80" :row-class-name="tableRowClassName">
            <!-- 小区 -->
            <el-table-column prop="gardenName" :label="$t('lang.lab_village')">
              <template slot-scope="scope">{{scope.row.gardenName | valueIsNull}}</template>
            </el-table-column>
            <!-- 楼号 -->
            <el-table-column prop="houseName" :label="$t('lang.lab_buildingnum')">
              <template slot-scope="scope">{{scope.row.houseName | valueIsNull}}</template>
            </el-table-column>
            <!-- 单元 -->
            <el-table-column prop="unitName" :label="$t('lang.lab_isUnitId')">
              <template slot-scope="scope">{{scope.row.unitName | valueIsNull}}</template>
            </el-table-column>
            <!-- 房间 -->
            <el-table-column prop="roomName" :label="$t('lang.lab_isRoomId')">
              <template slot-scope="scope">{{scope.row.roomName | valueIsNull}}</template>
            </el-table-column>
            <!-- 时间 -->
            <el-table-column prop="createTime" :label="$t('lang.lab_backgroundtime')" width="180">
              <template slot-scope="scope">{{ scope.row.createTime | time }}</template>
            </el-table-column>
            <!-- 巡检标准 -->
            <el-table-column prop="patrolStandardName" :label="$t('lang.lab_inspectionStandard')" width="200">
              <!-- <template slot-scope="scope">         
             <el-tooltip  placement="top" v-if="scope.row.patrolStandardName.length>3" :disabled="false"> 
               <div slot="content">{{scope.row.patrolStandardName}}</div>              
                <el-button
                  @click="patrol(scope.row.patrolStandard)"
                >{{ scope.row.patrolStandardName | ellipsis}}
                 </el-button> 
            </el-tooltip>    
                 <el-tooltip  placement="top" v-else :disabled="true"> 
               <div slot="content">{{scope.row.patrolStandardName}}</div>              
                <el-button
                  @click="patrol(scope.row.patrolStandard)"
                >{{ scope.row.patrolStandardName | ellipsis}}
                 </el-button> 
            </el-tooltip>                        
            </template> -->
              <template slot-scope="scope">
                <el-tooltip placement="top" v-if="scope.row.patrolStandardName.length>30" :disabled="false">
                  <div @click="patrol(scope.row.patrolStandard)" slot="content">{{scope.row.patrolStandardName}}</div>
                  <p style="color:#3A8DFC;" @click="patrol(scope.row.patrolStandard)">{{ scope.row.patrolStandardName}}
                  </p>
                </el-tooltip>
                <el-tooltip placement="top" v-else :disabled="true">
                  <div @click="patrol(scope.row.patrolStandard)" slot="content">{{scope.row.patrolStandardName}}</div>
                  <p style="color:#3A8DFC;" @click="patrol(scope.row.patrolStandard)">{{ scope.row.patrolStandardName}}
                  </p>
                </el-tooltip>
              </template>
            </el-table-column>
            <!-- 访谈方式 -->
            <el-table-column label="访谈方式" v-if="this.form.maintainType2 != null && this.form.maintainType2.id == '196'" prop="questionAnswerOption" width="100">
              <template slot-scope="scope">
                <span>{{ scope.row.questionAnswerOption || '--' }}</span>
              </template>
            </el-table-column>
            <!-- 完成情况 -->
            <el-table-column :label="$t('lang.lab_finishstatue')" width="180">
              <template slot-scope="scope">
                <span v-if="scope.row.state===0">{{$t('lang.lab_nofinish')}} ：{{scope.row.info}}</span>
                <span v-else-if="scope.row.state===1">{{$t('lang.lab_aleryfinish')}} ：{{scope.row.info}}</span>
                <span v-else-if="scope.row.state===3">{{$t('lang.lab_misss')}} ：{{scope.row.info}}</span>
                <span v-else>{{$t('lang.lab_unfinishs')}} ：{{scope.row.info}}</span>
              </template>
            </el-table-column>
            <!-- 图片详情 -->
            <el-table-column :label="$t('lang.lab_photodetail')" width="240">
              <template slot-scope="scope">
                <viewer :images="scope.row.urls">
                  <img v-for="(src,index) in scope.row.urls" :src="src" :key="index" class="img" />
                </viewer>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination class="input" @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="pageNum" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :page-count="pageCount" />
        </el-form-item>
        <el-divider></el-divider>
      </el-form>
      <!-- 巡检设备完成进度 -->
      <el-form ref="form" :model="form" v-if="showDevice" :label-width="require('@/config/enum').c_w8"
        :label-suffix="require('@/config/enum').c_colon">
        <el-form-item :label="$t('lang.lab_Device')">
          <div v-for="(md,index) in maintainDevice" :key="index">
            <p>
              {{md.createTime|time}}&emsp;
              <button type="button">{{md.deviceName}}</button>
              &emsp;
              <span v-if="md.state===0">{{$t('lang.lab_nofinish')}} ：{{md.info}}</span>
              <span v-else-if="md.state===1">{{$t('lang.lab_aleryfinish')}} ：{{md.info}}</span>
              <span v-else>{{$t('lang.lab_unfinishs')}} ：{{md.info}}</span>
            </p>
            <viewer :images="md.urls">
              <img v-for="(src,index) in md.urls" :src="src" :key="index" class="img" />
            </viewer>
          </div>
        </el-form-item>
        <el-divider></el-divider>
      </el-form>
      <!-- 巡检设备备注上传图片 -->
      <el-form :rules="rulesbs" v-if="this.form.state === 2 && showToDoDevice" ref="formsbs" :model="formsbs"
        :label-width="require('@/config/enum').c_w8" :label-suffix="require('@/config/enum').c_colon">
        <!-- 巡检设备 -->
        <el-form-item :label="$t('lang.lab_Devices')" prop="maintainDeviceToDos">
          <el-select v-model="formsbs.maintainDeviceToDos">
            <el-option key :label="$t('lang.lab_please_Select')+$t('lang.lab_Devices')" value></el-option>
            <el-option v-for="(item,index) in maintainDeviceToDo" :key="index" :label="item.deviceName"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- 备注 -->
        <el-form-item :label="$t('lang.lab_remark')">
          <el-input class="input" v-model="formsbs.infodevs"></el-input>
        </el-form-item>
        <!-- 上传图片设备 -->
        <el-form-item :label="$t('lang.lab_uploadPhotograph')" prop="files">
          <upload-morefile ref="uploading" :accept='accept' upTypes='1' :clears='clears' @outputFile="getFilesb"
            @removeFile='removeFilesb'></upload-morefile>
        </el-form-item>
        <!-- 完成, 异常 -->
        <el-button class="btn-first" type="primary" @click="finishdevide('formsbs')">{{$t('lang.btn_finishs')}}
        </el-button>
        <el-button class="btn_orange detailbtn" @click="unfinishdevide('formsbs')">{{$t('lang.btn_unfinishs')}}
        </el-button>
        <el-divider></el-divider>
      </el-form>
      <!-- 巡检标准 -->
      <el-form class="matop" :rules="rulebzs" v-if="this.form.state === 2 && showToDo" ref="formbzs" :model="formbzs"
        :label-width="require('@/config/enum').c_w8" :label-suffix="require('@/config/enum').c_colon">
        <el-form-item :label="$t('lang.lab_inspectionStandard')" prop="maintainPatrolToDos">
          <el-select v-model="formbzs.maintainPatrolToDos">
            <el-option key :label="$t('lang.lab_please_Select')+$t('lang.lab_inspectionStandard')" value></el-option>
            <el-option v-for="(item,index) in maintainPatrolToDo" :key="index" :label="item.patrolStandardName"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- 备注 -->
        <el-form-item :label="$t('lang.lab_remark')">
          <el-input v-model="formbzs.infos"></el-input>
        </el-form-item>
        <!-- 上传图片巡检标准 -->
        <el-form-item :label="$t('lang.lab_uploadPhotograph')" prop="files">
          <upload-morefile ref="uploading" :accept='accept' upTypes='1' :clears='clears' @outputFile="getFilexjbz"
            @removeFile='removeFilexjbz'></upload-morefile>
        </el-form-item>
        <!-- 完成, 异常 -->
        <el-button type="primary" class="btn-first" @click="finishpatro('formbzs')">{{$t('lang.btn_finishs')}}
        </el-button>
        <el-button class="btn_orange detailbtn" @click="unfinishpatro('formbzs')">{{$t('lang.btn_unfinishs')}}
        </el-button>
        <el-divider></el-divider>
      </el-form>
      <!-- 处理工单, 强制派单 -->
      <el-button v-if="this.form.state === 1" type="primary" class="btn-first" @click="collapseOne()">
        {{$t('lang.btn_collapseOne')}}</el-button>
      <el-button class="detailbtn" v-if="this.form.state === 1" type="primary" @click="collapseTwo()">
        {{$t('lang.btn_collapseTwo')}}</el-button>
      <el-form v-show="this.form.state === 1&&jdshow" ref="formjd" :rules="rulejd" :model="formjd"
        :label-width="require('@/config/enum').c_w8" :label-suffix="require('@/config/enum').c_colon" :inline="true"
        class="matop">
        <!-- 报事分类 -->
        <el-form-item :label="$t('lang.lab_groundSupplytype')" prop="maintainTypeId1">
          <el-select v-model="formjd.maintainTypeId1" @change="selectSecondjd">
            <el-option key :label="$t('lang.lab_firstLevel')" value></el-option>
            <el-option v-for="(item,index) in firstLevellist" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="maintainTypeId2" v-if="secondLevellist.length>0">
          <el-select v-model="formjd.maintainTypeId2" @change="selectThirdjd">
            <el-option key :label="$t('lang.lab_secondLevel')" value></el-option>
            <el-option v-for="(item,index) in secondLevellistjd" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="maintainTypeId3" v-if="thirdLevellist.length>0">
          <el-select v-model="formjd.maintainTypeId3">
            <el-option key :label="$t('lang.lab_thirdLevel')" :value="0"></el-option>
            <el-option v-for="(item,index) in thirdLevellistjd" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <br />
        <!-- 回复客户 -->
        <el-form-item :label="$t('lang.lab_backgroundreplyCon')">
          <el-input type="textarea" maxlength="200" v-model="Conlistname" class="replyCon"></el-input>
        </el-form-item>
        <el-form-item class="custom">
          <el-select v-model="Conlistname">
            <el-option v-for="(item,index) in Conlist" :key="index" :label="item" :value="item">
              <span style="float: left">{{ item }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <br />
        <!-- 接单 -->
        <el-button class="btn-first mat-22" type="primary" @click="orderreceiving('formjd')">
          {{$t('lang.btn_orderreceiving')}}</el-button>
      </el-form>
      <el-form v-show="this.form.state === 1&&pdshow" ref="formpd" :rules="rulepd" :model="formpd"
        :label-width="require('@/config/enum').c_w8" :label-suffix="require('@/config/enum').c_colon" :inline="true"
        class="matop">
        <!-- 报事分类 -->
        <el-form-item :label="$t('lang.lab_groundSupplytype')" prop="maintainTypeId1">
          <el-select v-model="formpd.maintainTypeId1" @change="selectSecondpd">
            <el-option key :label="$t('lang.lab_firstLevel')" value></el-option>
            <el-option v-for="(item,index) in firstLevellist" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="maintainTypeId2">
          <el-select v-model="formpd.maintainTypeId2" @change="selectThirdpd">
            <el-option key :label="$t('lang.lab_secondLevel')" value></el-option>
            <el-option v-for="(item,index) in secondLevellistpd" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="maintainTypeId3">
          <el-select v-model="formpd.maintainTypeId3">
            <el-option key :label="$t('lang.lab_thirdLevel')" :value="0"></el-option>
            <el-option v-for="(item,index) in thirdLevellistpd" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <br />
        <el-form-item :label="$t('lang.lab_backgroundsendorders')">
          <el-input type="textarea" maxlength="200" v-model="sendcontent" class="replyCon"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_backgroundsendpeople')" prop="peopleid">
          <el-select v-model="formpd.peopleid"
            :placeholder="$t('lang.lab_please_Select')+$t('lang.lab_backgroundsendpeople')">
            <el-option v-for="(item,index) in peoplelist" :key="index" :label="item.idNo"
              :value="item.idNo+','+item.id"></el-option>
          </el-select>
        </el-form-item>
        <br />
        <el-button class="btn-first mat-22" type="primary" @click="preceiving('formpd')">{{$t('lang.btn_sendorders')}}
        </el-button>
      </el-form>
      <!-- 处理中工单 -->
      <el-form v-if="this.form.state === 2 && !showToDo && !showToDoDevice" ref="formpj" :rules="rulepj" :model="formpj"
        class="matop" :label-width="require('@/config/enum').c_w8" :label-suffix="require('@/config/enum').c_colon">
        <el-form-item :label="$t('lang.lab_backgroundInfo')">
          <el-input class="input" type="textarea" maxlength="200" v-model="formpj.contents"
            :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_backgroundInfo')"></el-input>
        </el-form-item>
        <!-- 上传图片 -->
        <el-form-item :label="$t('lang.lab_uploadPhotograph')" prop="files">
          <upload-morefile ref="uploading" :accept='accept' upTypes='1' :clears='clears' @outputFile="getFile"
            @removeFile='removeFile'></upload-morefile>
        </el-form-item>
        <!-- 上传附件 -->
        <el-form-item :label="$t('lang.lab_accessories')" prop="withFiles">
          <upload-morefile ref="uploading" upTypes='0' :clears='clears' @outputFile="getFilefj"
            @removeFile='removeFilefj'></upload-morefile>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_backgroundhardEvaluation')" prop="difficulty">
          <el-radio-group v-model="formpj.difficulty">
            <el-radio v-for="(item,index) in evaluationlist" :label="item.id" :key="index" :value="item.id">
              {{item.name}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-button class="btn-first" type="primary" v-if="this.form.staff&&this.form.staff.id!=null&&this.form.staff.id==this.userDataid"
          @click="finish()">{{$t('lang.btn_finish')}}</el-button>
        <!-- <el-button class="detailbtn" type="primary" @click="print()">{{$t('lang.btn_print')}}</el-button> -->
      </el-form>
      <!-- 待评价 -->
      <el-form ref="forms" v-if="this.form.state === 3 && this.form.userId === this.userDataid" :model="forms"
        :label-width="require('@/config/enum').c_w8" :label-suffix="require('@/config/enum').c_colon">
        <!-- 是否对业主显示  -->
        <el-form-item :label="$t('lang.lab_backgroundhardyzshow')">
          <el-radio-group v-model="forms.yzshow">
            <el-radio v-for="(item,index) in yzshowlist" :label="item.id" :key="index" :value="item.id">{{item.name}}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 评价等级 -->
        <el-form-item :label="$t('lang.lab_backgroundoneEvaluation')">
          <el-radio-group v-model="grade">
            <el-radio v-for="(item,index) in evaluationslist" :key="index" :label="item.id" :value="item.id">
              {{item.name}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 评语 -->
        <el-form-item :label="$t('lang.lab_comment')">
          <el-checkbox-group v-model="gradeconlist" class="chooseActive">
            <el-checkbox v-for="(item,index) in orderlist" :key="index" :label="item.id" :value="item.id"
              :title="item.twoEvaluation">{{item.twoEvaluation}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_backgroundtexts')">
          <el-input maxlength="200" class="input" type="textarea" v-model="forms.contents"
            :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_backgroundtexts')"></el-input>
        </el-form-item>
        <!-- 图片上传 -->
        <el-form-item :label="$t('lang.lab_uploadPhotograph')" prop="files">
          <upload-morefile ref="uploading" :accept='accept' upTypes='1' @outputFile="getFilepj"
            @removeFile='removeFilepj'></upload-morefile>
        </el-form-item>
        <el-button class="btn-first" type="primary" @click="appraise()">{{$t('lang.btn_appraise')}}</el-button>
      </el-form>
      <el-form ref="cancelFileRef" :model="cancelFileFrom" :rules="cancelFileRule" v-if="this.form.state === 7"
        :label-width="require('@/config/enum').c_w4" :label-suffix="require('@/config/enum').c_colon">
        <el-form-item :label="$t('lang.lab_mobile')" prop="cancelFile">
          <!-- <el-upload
              class="upload-demo"
              :on-success="handleSuccesscancel"
              :on-remove="handleRemovecancel"
              :on-error="uploadErr12"
              v-model="cancelFileFrom.cancelFile"
              name="files"
              :action="require('@/config/enum').actionname"
              list-type="picture-card"
              :file-list="cancelFileList"
            >
              <el-button size="small" type="primary">{{$t('lang.up_file')}}</el-button>
            </el-upload> -->
          <upload-morefile ref="uploading" upTypes='1' @outputFile="getFileCancel" @removeFile='removeFileCancel'>
          </upload-morefile>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="fileCancelSubmit('cancelFileRef')">{{$t('lang.btn_save')}}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <!-- 关闭工单弹窗 -->
    <el-dialog :visible.sync="showgd" :close-on-click-modal="false" center top="130px" width="600px" :title="titlegd"
      custom-class="detailPosition" @closed="gbhandleDialogClosed">

      <el-form ref="formgb" :rules="rulegb" :model="formgb" :label-width="require('@/config/enum').c_ws6"
        :label-suffix="require('@/config/enum').c_colon">
        <el-form-item :label="$t('lang.lab_isclosetext')" prop="isNormalClose">
          <el-radio-group v-model="formgb.isNormalClose">
            <el-radio v-for="item in isNormalCloselist" :label="item.id" :key="item.id">{{item.name}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_closetext')" prop="desc">
          <el-input maxlength="200" v-model="formgb.desc"
            :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_closetext')"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="gbhandleDialogClosed()">{{$t('lang.btn_rest')}}</el-button>
        <el-button type="primary" @click="gbonSubmit('formgb')">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
    <!-- 审阅工单 -->
    <el-dialog :visible.sync="showsy" :close-on-click-modal="false" center top="140px" width="600px" :title="titlesy"
      custom-class="detailPosition" @closed="syhandleDialogClosed">

      <el-form ref="formsy" :model="formsy" :label-width="require('@/config/enum').c_w4"
        :label-suffix="require('@/config/enum').c_colon">
        <el-form-item :label="$t('lang.lab_isread')">
          <el-radio-group v-model="formsy.isCheck">
            <el-radio v-for="item in isreadlist" :label="item.id" :key="item.id">{{item.name}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_readtext')">
          <el-input maxlength="200" v-model="formsy.readtext"
            :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_readtext')"></el-input>
        </el-form-item>
        <!-- 图片上传 -->
        <el-form-item :label="$t('lang.lab_uploadPhotograph')" prop="filessy">
          <upload-morefile ref="uploading" :accept='accept' upTypes='1' @outputFile="getFilesy"
            @removeFile='removeFilesy'></upload-morefile>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="syhandleDialogClosed()">{{$t('lang.btn_rest')}}</el-button>
        <el-button type="primary" @click="syonSubmit">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
    <!-- 变更报事类型 -->
    <el-dialog :visible.sync="showupdate" :close-on-click-modal="false" center top="130px" width="600px"
      :title="titleupdate" custom-class="detailPosition" @closed="bghandleDialogClosed">

      <el-form ref="formbg" :rules="rulebg" :model="formbg" :label-width="require('@/config/enum').c_ws6"
        :label-suffix="require('@/config/enum').c_colon">
        <el-form-item :label="$t('lang.lab_backgroundmaintainType1')" prop="maintainTypeId1">
          <el-select v-model="formbg.maintainTypeId1" @change="selectSecond">
            <el-option key :label="$t('lang.lab_firstLevel')" value></el-option>
            <el-option v-for="(item,index) in firstLevellist" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_backgroundmaintainType2')" prop="maintainTypeId2">
          <el-select v-model="formbg.maintainTypeId2" @change="selectThird">
            <el-option key :label="$t('lang.lab_secondLevel')" value></el-option>
            <el-option v-for="(item,index) in secondLevellist" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_backgroundmaintainType3')" prop="maintainTypeId3">
          <el-select v-model="formbg.maintainTypeId3">
            <el-option key :label="$t('lang.lab_thirdLevel')" :value="0"></el-option>
            <el-option v-for="(item,index) in thirdLevellist" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_updatetext')" prop="readtext">
          <el-input type="textarea" maxlength="100" v-model="formbg.readtext"
            :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_updatetext')"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="bghandleDialogClosed()">{{$t('lang.btn_rest')}}</el-button>
        <el-button type="primary" @click="saveupdateTypeMaintains('formbg')">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
    <!-- 延时工单 -->
    <el-dialog :visible.sync="showys" :close-on-click-modal="false" center top="130px" width="600px" :title="titleys"
      custom-class="detailPosition" @closed="yshandleDialogClosed">

      <el-form ref="form" :model="form" :label-width="require('@/config/enum').c_w4"
        :label-suffix="require('@/config/enum').c_colon">
        <el-form-item :label="$t('lang.lab_delaytext')">
          <el-input maxlength="200" v-model="ysreadtext"
            :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_delaytext')"></el-input>
        </el-form-item>
        <!-- 图片上传 -->
        <el-form-item :label="$t('lang.lab_uploadPhotograph')" prop="filessy">
          <upload-morefile ref="uploading" :accept='accept' upTypes='1' @outputFile="getFileys"
            @removeFile='removeFileys'></upload-morefile>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="yshandleDialogClosed()">{{$t('lang.btn_rest')}}</el-button>
        <el-button type="primary" @click="ysonSubmit">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
    <!-- 跟进工单 -->
    <el-dialog :visible.sync="showgj" :close-on-click-modal="false" center top="130px" width="600px" :title="titlegj"
      custom-class="detailPosition" @closed="gjhandleDialogClosed">

      <el-form ref="formgj" :rules="rulegj" :model="formgj" :label-width="require('@/config/enum').c_w4"
        :label-suffix="require('@/config/enum').c_colon">
        <el-form-item :label="$t('lang.lab_appandtext')" prop="readtext">
          <el-input maxlength="4000" v-model="formgj.readtext"
            :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_appandtext')"></el-input>
        </el-form-item>
        <!-- 图片上传跟进 -->
        <el-form-item :label="$t('lang.lab_uploadPhotograph')" prop="filessy">
          <upload-morefile ref="uploading" :accept='accept' upTypes='1' @outputFile="getFilegj"
            @removeFile='removeFilegj'></upload-morefile>
        </el-form-item>
        <!-- 附件上传跟进 -->
        <el-form-item :label="$t('lang.lab_accessories')" prop="withFiles">
          <upload-morefile ref="uploading" upTypes='0' @outputFile="getFilegjfj" @removeFile='removeFilegjfj'>
          </upload-morefile>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="gjhandleDialogClosed()">{{$t('lang.btn_rest')}}</el-button>
        <el-button type="primary" @click="gjonSubmit('formgj')">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
    <!-- 转移工单 -->
    <el-dialog :visible.sync="showzy" :close-on-click-modal="false" center top="130px" width="600px" :title="titlezy"
      custom-class="detailPosition" @closed="zyhandleDialogClosed">

      <el-form ref="formzy" :model="formzy" :rules="rulezy" :label-width="require('@/config/enum').c_w4"
        :label-suffix="require('@/config/enum').c_colon">
        <el-form-item :label="$t('lang.lab_changeto')" prop="changeto">
          <el-select v-model="formzy.changeto" filterable>
            <el-option v-for="(item,index) in changetolist" :key="index" :label="item.idNo" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_changetext')" prop="readtext">
          <el-input maxlength="200" v-model="formzy.readtext"
            :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_changetext')"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="zyhandleDialogClosed()">{{$t('lang.btn_rest')}}</el-button>
        <el-button type="primary" @click="zyonSubmit('formzy')">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
    <!-- 回访工单 -->
    <el-dialog :visible.sync="showhf" :close-on-click-modal="false" center top="130px" width="600px" :title="titlehf"
      custom-class="detailPosition" @closed="hfhandleDialogClosed">

      <el-form ref="formhf" :rules="rulehf" :model="formhf" :label-width="require('@/config/enum').c_w4"
        :label-suffix="require('@/config/enum').c_colon">
        <el-form-item :label="$t('lang.lab_hftext')" prop="readtext">
          <el-input v-model="formhf.readtext" :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_appandtext')">
          </el-input>
        </el-form-item>
        <!-- 图片上传回访 -->
        <el-form-item :label="$t('lang.lab_uploadPhotograph')">
          <upload-morefile ref="uploading" :accept='accept' upTypes='1' @outputFile="getFilehf"
            @removeFile='removeFilehf'></upload-morefile>
        </el-form-item>
        <!-- 附件上传回访 -->
        <el-form-item :label="$t('lang.lab_accessories')" prop="withFiles">
          <upload-morefile ref="uploading" upTypes='0' @outputFile="getFilehffj" @removeFile='removeFilehffj'>
          </upload-morefile>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="hfhandleDialogClosed()">{{$t('lang.btn_rest')}}</el-button>
        <el-button type="primary" @click="hfonSubmit('formhf')">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
    <!-- 巡检标准预览 -->
    <el-dialog :visible.sync="showpatrol" :close-on-click-modal="false" center top="130px" width="600px"
      custom-class="detailPosition" :title="$t('lang.lab_inspectionStandardPreview')">
      <el-scrollbar>
        <el-form ref="formpatrol" :model="formpatrol" :label-width="require('@/config/enum').c_w4"
          :label-suffix="require('@/config/enum').c_colon">
          <el-form-item :label="$t('lang.lab_standardName')">{{this.formpatrol.name}}</el-form-item>
          <el-form-item :label="$t('lang.lab_standardMethod')">{{this.formpatrol.info}}</el-form-item>
          <el-form-item :label="$t('lang.lab_photograph')">
            <viewer :images="this.formpatrol.urls">
              <img v-for="(src,index) in this.formpatrol.urls" :src="src" :key="index" class="img" />
            </viewer>
          </el-form-item>
        </el-form>
      </el-scrollbar>
    </el-dialog>
    <!-- 巡检路线弹框 -->
    <el-dialog :visible.sync="patrolPointLineshow" :close-on-click-modal="false" center top="130px" width="600px"
      custom-class="detailPosition">
      <el-scrollbar>
        <el-form ref="patrolPointLine" :model="patrolPointLine" :label-width="require('@/config/enum').c_w4"
          :label-suffix="require('@/config/enum').c_colon">
          <el-form-item :label="$t('lang.lab_standardName')">{{this.patrolPointLine.name}}</el-form-item>
          <el-form-item :label="$t('lang.lab_patrol_point_order')">{{this.patrolPointLine.patrolPointLineSeq}}
          </el-form-item>
          <el-form-item :label="$t('lang.lab_patrol_point_group')">{{this.patrolPointLine.patrolPointLinePerson}}
          </el-form-item>
          <el-form-item :label="$t('lang.lab_patrol_point')">
            <img v-for="(src,index) in this.patrolPointLineurls" :src="src" :key="index" class="img"
              @click="imgshowto(src)" />
          </el-form-item>
        </el-form>
      </el-scrollbar>
    </el-dialog>
    <!-- 点位弹窗 -->
    <el-dialog :visible.sync="imgshow" :close-on-click-modal="false" center top="130px" width="750px">
      <div ref="imageTofile">
        <div v-for="(item, index) in sign" :key="index.pointId">
          <el-popover placement="top" trigger="hover" :title="pointName">
            <p class="height_all">{{item.msg}}</p>
            <div style="text-align: right; margin: 0; bottom: 0;">
              <el-button type="success" size="mini" @click="seeQrImg(item.pointId, item.msg)">
                {{$t('lang.lab_seeQrCodes')}}</el-button>
            </div>
            <div
              :style="'left:' + item.left + ';' + 'top:' + item.top + ';' + 'background-image:url(' + item.ptypecss + ');'"
              class="pointImg" slot="reference"></div>
          </el-popover>
          <div :style="'left:' + item.left + ';' + 'top:' + item.top " class="pointSpan">
            <span>{{item.msg}}</span>
          </div>
        </div>
        <img :src="getImgUrl" class="getImg" />
      </div>
    </el-dialog>
    <!-- 二维码 -->
    <el-dialog :visible.sync="showQr" :close-on-click-modal="false" center top="130px" width="320px" height="320px"
      :title="QrTitle">
      <vue-qr :text="qrText + ''" :title="'{id:' + qrShowPointId +  '}'" :size="300"></vue-qr>
    </el-dialog>
    <!-- 巡检点位弹框 -->
    <el-dialog :visible.sync="rowPointshow" :close-on-click-modal="false" :title="$t('lang.lab_Patrol_Preview')" center
      top="130px" width="600px" custom-class="detailPosition">
      <el-scrollbar>
        <el-form ref="rowPoint" :model="rowPoint" :label-width="require('@/config/enum').c_w4"
          :label-suffix="require('@/config/enum').c_colon">
          <el-form-item :label="$t('lang.lab_pointName')">{{this.rowPoint.pointName}}</el-form-item>
          <el-form-item :label="$t('lang.lab_Explain')">{{this.patrolPointLine.info}}</el-form-item>
          <el-form-item :label="$t('lang.lab_photograph')">
            <viewer :images="this.rowPoint.urls">
              <img v-for="(src,index) in this.rowPoint.urls" :src="src" :key="index" class="img" />
            </viewer>
          </el-form-item>
        </el-form>
      </el-scrollbar>
    </el-dialog>
  </div>
</template>

<script>
  /**
   *@ClassName:400backgroundDetail
   *@Description:400详情
   *@author:孙斯维
   *@Copyright:格众科技
   *@date:2020-03-17
   */
  import uploadmoreFile from '../../../components/upload_morefile.vue'
  import {
    mapGetters
  } from 'vuex'

  export default {
    filters: {
      ellipsis(value) {
        if (!value) return ''
        if (value.length > 3) {
          return value.slice(0, 3) + '...'
        }
        return value
      }
    },
    data() {
      return {
        clears: false, // 清空按钮
        accept: '.jpg, .jpeg, .png',
        getImgUrl: '', // 获取的图片URL
        is400: false, // 撤销投诉按钮
        showQr: false, // 查看二维码的弹框
        QrTitle: '', // 查看二维码弹框的title
        qrText: '', // 查看二维码图片左边的名称
        qrShowPointId: '', // 查看二维码显示的内容
        imgshow: false, // 点位弹框显示
        sign: [], // 获取原来图片添加点位的参数数组
        pageCount: 0, // 总页数
        pageNum: 1, // 页数
        pageSize: 10, // 每页显示数量
        rowPoint: {}, // 巡检路线点位弹框对象
        rowPointshow: false, // 巡检路线点位弹框显示
        patrolPointLineshow: false, // 弹窗巡检路线
        patrolPointLineurls: [], // 巡检线路弹窗图片
        showpatrol: false, // 弹窗巡检标准
        jindu: '', // 进度
        show: false, // 巡检标准是否显示
        showToDo: false, // 巡检标准todo是否显示
        showPL: false, // 巡检路线是否显示
        showDevice: false, // 巡检设备是否显示
        showToDoDevice: false, // 巡检设备todo是否显示
        maintainPatrol: [], // 巡检标准list
        maintainPatrolToDo: [], // 巡检标准todolist
        maintainPatrolPointLineToDo: [], // 巡检路线todolist
        maintainPatrolPointLine: [], // 巡检路线list
        maintainDeviceToDo: [], // 巡检设备todolist
        maintainDevice: [], // 巡检设备list
        ysreadtext: '', // 延时工单延时原因
        sendcontent: '', // 派单备注
        peoplelist: [], // 人员分配list
        pdshow: false, // 派单按钮点选动态变化
        jdshow: false, // 接单按钮点选动态变化
        images: [], // 图片集合
        id: '', // 详情id
        changetolist: [], // 转移工单list
        titlegd: this.$i18n.t('lang.titlegd'), // 关闭工单
        showgd: false, // 关闭工单弹框开关
        titlesy: this.$i18n.t('lang.titlesy'), // 审阅工单
        showsy: false, // 审阅工单弹框开关
        titleupdate: this.$i18n.t('lang.titleupdate'), // 修改报事类型
        showupdate: false, // 审阅工单弹框开关
        titleys: this.$i18n.t('lang.titleys'), // 延时工单
        showys: false, // 延时工单弹框开关
        titlegj: this.$i18n.t('lang.titlegj'), // 跟进工单
        showgj: false, // 跟进工单弹框开关
        titlezy: this.$i18n.t('lang.titlezy'), // 转移工单
        showzy: false, // 转移工单弹框开关
        titlehf: this.$i18n.t('lang.btn_followMaintainsres'), // 转移工单
        showhf: false, // 回访工单弹框开关
        fileListxjbz: [], // 巡检标准上传
        fileListsb: [], // 巡检设备上传
        fileListfj: [], // 附件上传
        fileList: [], // 图片上传
        fileListys: [], // 延时工单图片上传
        fileListsy: [], // 审阅工单图片上传
        fileListdpj: [], // 待评价图片上传
        fileListgj: [], // 跟进工单图片list
        fileListgjfj: [], // 跟进工单附件list
        fileListhf: [], // 回访工单图片list
        fileListhffj: [], // 跟进工单附件list
        Conlistname: this.$i18n.t('lang.lab_iscontent'), // 回复客户绑定值
        Conlist: this.$i18n.t('lang.NewspaperInfoDetail.Conlist'), // 回复客户list
        yzshowlist: this.$i18n.t('lang.NewspaperInfoDetail.yzshowlist'), // 是否对业主显示list
        evaluationslist: this.$i18n.t('lang.NewspaperInfoDetail.evaluationslist'), // 评价等级list
        evaluationlist: this.$i18n.t('lang.NewspaperInfoDetail.evaluationlist'), // 难易等级list
        isNormalCloselist: this.$i18n.t(
          'lang.NewspaperInfoDetail.isNormalCloselist1'
        ), // 关闭工单中list
        isreadlist: this.$i18n.t('lang.NewspaperInfoDetail.isreadlist'), // 审阅工单中list
        typeleval: 1, // 级别接口区分字段
        firstLevellist: [], // 一级分类list
        secondLevellist: [], // 二级分类list
        secondLevellistjd: [], // 二级分类list
        secondLevellistpd: [], // 二级分类list
        thirdLevellist: [], // 三级分类list
        thirdLevellistjd: [], // 三级分类list
        thirdLevellistpd: [], // 三级分类list
        tableData: [], // 工单一生list
        fileslist: [], // 保存图片list
        fileslistxjbz: [], // 巡检标准保存图片list
        fileslistsb: [], // 巡检设备保存图片list
        withFileslist: [], // 保存附件list
        fileslistdpj: [], // 保存待评价图片list
        fileslistys: [], // 保存延时工单图片list
        fileslistsy: [], // 保存审阅工单图片list
        fileslistgj: [], // 保存跟进工单图片list
        fileslistgjfj: [], // 保存跟进工单fjlist
        fileslisthf: [], // 保存回访工单图片list
        fileslisthffj: [], // 保存回访工单fjlist
        orderlist: [], // 评语list
        gradeconlist: [], // 选择评语list
        cancelFileList: [], // 撤销投诉list
        grade: 1,
        patrolPointLine: {}, // 巡检线路弹窗对象
        formpd: {
          maintainTypeId1: '',
          maintainTypeId2: '',
          maintainTypeId3: 0
        }, // 派单
        formjd: {
          maintainTypeId1: '',
          maintainTypeId2: '',
          maintainTypeId3: 0
        }, // 接单
        forms: {}, // 待评价对象
        formsbs: {
          maintainDeviceToDos: '' // 巡检设备
        }, // 巡检设备对象
        formbzs: {
          maintainPatrolToDos: '' // 巡检标准
        }, // 巡检标准对象
        formpj: {
          difficulty: 1, // 难易评价
          contents: ''
        }, // 待评价对象
        form: {}, // 查询对象
        formhf: {
          readtext: ''
        }, // 回访工单
        formzy: {
          readtext: '',
          changeto: ''
        }, // 转移工单
        formsy: {
          isCheck: 1,
          readtext: ''
        }, // 审阅工单
        formgj: {
          readtext: ''
        }, // 跟进工单
        formgb: {
          isNormalClose: 1,
          desc: ''
        }, // 关闭工单
        formbg: {
          readtext: '',
          maintainTypeId1: '',
          maintainTypeId2: '',
          maintainTypeId3: 0,
          content: ''
        }, // 变更报事类型
        formpatrol: {}, // 弹窗
        cancelFileFrom: {
          cancelFile: ''
        },
        rulehf: {
          readtext: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Input') +
              this.$i18n.t('lang.lab_hftext'),
            trigger: 'blur'
          }]
        }, // 回访工单表单验证
        rulezy: {
          changeto: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.lab_changeto'),
            trigger: 'change'
          }],
          readtext: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Input') +
              this.$i18n.t('lang.lab_changetext'),
            trigger: 'blur'
          }]
        }, // 转移工单表单验证
        rulegj: {
          readtext: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Input') +
              this.$i18n.t('lang.lab_appandtext'),
            trigger: 'blur'
          }]
        }, // 跟进工单表单验证
        rulesbs: {
          maintainDeviceToDos: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.lab_inspectionDevice'),
            trigger: 'change'
          }]
        },
        rulebzs: {
          maintainPatrolToDos: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.lab_inspectionStandard'),
            trigger: 'change'
          }]
        },
        rulepj: {
          difficulty: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.lab_backgroundhardEvaluation'),
            trigger: 'change'
          }]
        },
        rulepd: {
          peopleid: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.lab_backgroundsendpeople'),
            trigger: 'change'
          }],
          maintainTypeId1: [{
            required: true,
            message: this.$i18n.t('lang.lab_firstLevel'),
            trigger: 'change'
          }]
        },
        rulejd: {
          maintainTypeId1: [{
            required: true,
            message: this.$i18n.t('lang.lab_firstLevel'),
            trigger: 'change'
          }]
        },
        rulebg: {
          maintainTypeId1: [{
            required: true,
            message: this.$i18n.t('lang.lab_firstLevel'),
            trigger: 'change'
          }],
          readtext: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Input') +
              this.$i18n.t('lang.lab_updatetext'),
            trigger: 'blur'
          }]
        }, // 变更工单表单验证
        rulegb: {
          isNormalClose: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.lab_isclosetext'),
            trigger: 'change'
          }],
          desc: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Input') +
              this.$i18n.t('lang.lab_closetext'),
            trigger: 'blur'
          }]
        }, // 关闭工单表单验证
        cancelFileRule: {
          cancelFile: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Upload'),
            trigger: 'change'
          }]
        },
        review: 0, // 审阅工单权限
        haveChild: 0 // 是否有子工单
      }
    },
    watch: {
      grade() {
        this.getEvaluationDetailByGrade()
      }
    },
    components: {
      'upload-morefile': uploadmoreFile
    },
    computed: {
      ...mapGetters({
        userDataid: 'staffId',
        isClose: 'isClose',
        gardenId: 'gardenId',
        permission: 'permission'
      })
    },
    created() {
      console.log(this.permission)
      if (
        this.$store.getters.nickName.indexOf('400') != -1
      ) {
        this.is400 = true
      }
      this.haveChild = this.$route.query.haveChild
      // 获取是否有工单关闭权限
      if (this.$route.query.id) {
        this.id = this.$route.query.id
        // 工单的一生
        this.maintainLife()
        // 通过id查询详情
        this.maintains()
        this.maintainPatrols()
        this.maintainPatrolPointLines()
        this.maintainDevsices()
      }
      // 获取报事分类list
      this.maintainTypes()
      // 获取是否有审阅权限
      this.getStaffReview()
    },
    methods: {
      // 获取组件值
      getFile(e) {
        this.fileList.push({
          name: '',
          url: e
        })
      },
      // 移除图片
      removeFile(e) {
        let list1 = []
        for (let i = 0; i < this.fileList.length; i++) {
          if (this.fileList[i].url === e) {

          } else {
            list1.push(this.fileList[i])
          }
        }
        this.fileList = list1
      },
      // 附件获取组件值
      getFilefj(e) {
        this.fileListfj.push({
          name: '',
          url: e
        })
      },
      // 移除附件
      removeFilefj(e) {
        let list2 = []
        for (let i = 0; i < this.fileListfj.length; i++) {
          if (this.fileListfj[i].url === e) {

          } else {
            list2.push(this.fileListfj[i])
          }
        }
        this.fileListfj = list2
      },
      // 评价上传图片获取组件值
      getFilepj(e) {
        this.fileListdpj.push({
          name: '',
          url: e
        })
      },
      // 移除评价上传图片
      removeFilepj(e) {
        let list3 = []
        for (let i = 0; i < this.fileListdpj.length; i++) {
          if (this.fileListdpj[i].url === e) {

          } else {
            list3.push(this.fileListdpj[i])
          }
        }
        this.fileListdpj = list3
      },
      // 审阅上传图片获取组件值
      getFilesy(e) {
        this.fileListsy.push({
          name: '',
          url: e
        })
      },
      // 移除审阅上传图片
      removeFilesy(e) {
        let list4 = []
        for (let i = 0; i < this.fileListsy.length; i++) {
          if (this.fileListsy[i].url === e) {

          } else {
            list4.push(this.fileListsy[i])
          }
        }
        this.fileListsy = list4
      },
      // 延时上传图片获取组件值
      getFileys(e) {
        this.fileListys.push({
          name: '',
          url: e
        })
      },
      // 移除延时上传图片
      removeFileys(e) {
        let list5 = []
        for (let i = 0; i < this.fileListys.length; i++) {
          if (this.fileListys[i].url === e) {

          } else {
            list5.push(this.fileListys[i])
          }
        }
        this.fileListys = list5
      },
      // 跟进上传图片获取组件值
      getFilegj(e) {
        this.fileListgj.push({
          name: '',
          url: e
        })
      },
      // 移除跟进延时上传图片
      removeFilegj(e) {
        let list6 = []
        for (let i = 0; i < this.fileListgj.length; i++) {
          if (this.fileListgj[i].url === e) {

          } else {
            list6.push(this.fileListgj[i])
          }
        }
        this.fileListgj = list6
      },
      // 跟进上传附件获取组件值
      getFilegjfj(e) {
        this.fileListgjfj.push({
          name: '',
          url: e
        })
      },
      // 移除跟进上传附件
      removeFilegjfj(e) {
        let list7 = []
        for (let i = 0; i < this.fileListgjfj.length; i++) {
          if (this.fileListgjfj[i].url === e) {

          } else {
            list7.push(this.fileListgjfj[i])
          }
        }
        this.fileListgjfj = list7
      },
      // 回访上传图片获取组件值
      getFilehf(e) {
        this.fileListhf.push({
          name: '',
          url: e
        })
      },
      // 移除回访上传图片
      removeFilehf(e) {
        let list8 = []
        for (let i = 0; i < this.fileListhf.length; i++) {
          if (this.fileListhf[i].url === e) {

          } else {
            list8.push(this.fileListhf[i])
          }
        }
        this.fileListhf = list8
      },
      // 回访上传附件获取组件值
      getFilehffj(e) {
        // 杜，改fileListgjfj为fileListhffj
        this.fileListhffj.push({
          name: '',
          url: e
        })
      },
      // 移除回访上传附件
      removeFilehffj(e) {
        let list9 = []
        for (let i = 0; i < this.fileListhffj.length; i++) {
          if (this.fileListhffj[i].url === e) {

          } else {
            list9.push(this.fileListhffj[i])
          }
        }
        this.fileListhffj = list9
      },
      // 设备上传图片
      getFilesb(e) {
        this.fileListsb.push({
          name: '',
          url: e
        })
      },
      // 移除设备上传图片
      removeFilesb(e) {
        let list10 = []
        for (let i = 0; i < this.fileListsb.length; i++) {
          if (this.fileListsb[i].url === e) {

          } else {
            list10.push(this.fileListsb[i])
          }
        }
        this.fileListsb = list10
      },
      // 巡检标准上传图片
      getFilexjbz(e) {
        this.fileListxjbz.push({
          name: '',
          url: e
        })
      },
      // 移除巡检标准上传图片
      removeFilexjbz(e) {
        let list11 = []
        for (let i = 0; i < this.fileListxjbz.length; i++) {
          if (this.fileListxjbz[i].url === e) {

          } else {
            list11.push(this.fileListxjbz[i])
          }
        }
        this.fileListxjbz = list11
      },
      // 撤销投诉上传图片
      getFileCancel(e) {
        this.cancelFileList.push({
          name: '',
          url: e
        })
        this.cancelFileFrom.cancelFile = e
      },
      // 移除撤销投诉上传图片
      removeFileCancel(e) {
        let list12 = []
        for (let i = 0; i < this.cancelFileList.length; i++) {
          if (this.cancelFileList[i].url === e) {

          } else {
            list12.push(this.cancelFileList[i])
          }
        }
        this.cancelFileList = list12
      },
      // 撤销投诉
      complainCancel() {
        let loading = this.$loading()
        this.$patch(`/maintains/complainCancel/${this.id}`, {}).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.$message.success(this.$i18n.t('lang.lab_save_complainCancel'))
              this.is400 = false
              this.maintainLife()
              this.maintains()
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 撤销投诉
      fileCancelSubmit(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            let cancelFilesList = []
            if (this.cancelFileList.length > 0) {
              for (let i = 0; i < this.cancelFileList.length; i++) {
                cancelFilesList.push(this.cancelFileList[i].url)
              }
            }
            let params = {
              maintainId: this.id,
              files: cancelFilesList.toString()
            }
            let loading = this.$loading()
            this.$post(`/maintains/upWithFile`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.jump()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          }
        })
      },
      // 查看二维码
      seeQrImg(pointId, msg) {
        this.QrTitle = this.$i18n.t('lang.lab_seeQrCodes')
        this.qrText = msg
        this.qrShowPointId = pointId
        this.showQr = true
      },
      // 点位图
      imgshowto(urls) {
        this.getImgUrl = urls
        // 存储图片的宽高
        var img = new Image()
        img.src = this.getImgUrl
        this.left = img.width
        this.top = img.height
        this.imgshow = true
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNum = val
        this.maintainPatrols()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNum = 1
        this.pageSize = val
        this.maintainPatrols()
      },
      // 巡检线路
      updatePatrolPointId(row) {
        this.rowPoint = row
        this.rowPointshow = true
      },
      // 巡检线路弹框显示
      updatePatrolPointLineId(id) {
        let loading = this.$loading()
        this.$get(`/patrolPointLineById/${id}`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.patrolPointLine = res.patrolPointLine
              if (
                res.patrolPointLine.planarGraphId &&
                res.patrolPointLine.planarGraphId != null
              ) {
                this.planarGraphById(res.patrolPointLine.planarGraphId)
                this.getPointList(
                  this.patrolPointLine.gardenId,
                  this.patrolPointLine.planarGraphId,
                  this.patrolPointLine.patrolTypeId
                )
              } else {
                this.patrolPointLineshow = true
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 巡检路线通过id查询图片
      planarGraphById(id) {
        let loading = this.$loading()
        this.$get(`/planarGraphById/${id}`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.patrolPointLineurls = res.urls
              this.patrolPointLineshow = true
            } else {
              this.patrolPointLineshow = false
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 平面图点位
      getPointList(gardenId, planarGraphId, patrolTypeId) {
        let loading = this.$loading()
        this.$get(
          `/patrolPointList?GardenId=${gardenId}&PlanarGraphId=${planarGraphId}&PatrolTypeId=${patrolTypeId}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.sign = res.pointJsonArray
              if (this.sign.length > 0) {
                for (let i = 0; i < this.sign.length; i++) {
                  if (this.sign[i].ptypecss === '/images/patrol/pink.png') {
                    this.sign[i].ptypecss = require('../../../../images/patrol/pink.png')
                  } else if (
                    this.sign[i].ptypecss === '/images/patrol/blue.png'
                  ) {
                    this.sign[i].ptypecss = require('../../../../images/patrol/blue.png')
                  } else if (
                    this.sign[i].ptypecss === '/images/patrol/green.png'
                  ) {
                    this.sign[i].ptypecss = require('../../../../images/patrol/green.png')
                  } else if (
                    this.sign[i].ptypecss === '/images/patrol/yellow.png'
                  ) {
                    this.sign[i].ptypecss = require('../../../../images/patrol/yellow.png')
                  } else if (this.sign[i].ptypecss === '/images/patrol/red.png') {
                    this.sign[i].ptypecss = require('../../../../images/patrol/red.png')
                  }
                }
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 巡检标准预览弹窗
      patrol(patrolStandard) {
        let loading = this.$loading()
        this.$get(`/patrolStandardById/${patrolStandard}`).then(
          res => {
            loading.close()
            if (res) {
              this.formpatrol = res
              this.showpatrol = true
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 巡检标准完成
      finishpatro(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            // 上传图片
            if (this.fileListxjbz.length > 0) {
              for (let i = 0; i < this.fileListxjbz.length; i++) {
                this.fileslistxjbz.push(this.fileListxjbz[i].url)
              }
            }
            let params = {
              info: this.formbzs.infos,
              files: this.fileslistxjbz.toString(),
              state: 1
            }
            let loading = this.$loading()
            this.$patch(
              `/maintainPatrol/${this.formbzs.maintainPatrolToDos}`,
              params
            ).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_paperefinsh'))
                  this.formbzs.maintainPatrolToDos = ''
                  this.maintains()
                  this.maintainLife()
                  this.maintainPatrols()
                  this.maintainPatrolPointLines()
                  this.maintainDevsices()
                  this.cleanPatrols()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          }
        })
      },
      // 巡检标准异常
      unfinishpatro(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            // 上传图片
            if (this.fileListxjbz.length > 0) {
              for (let i = 0; i < this.fileListxjbz.length; i++) {
                this.fileslistxjbz.push(this.fileListxjbz[i].url)
              }
            }

            let params = {
              info: this.formbzs.infos,
              files: this.fileslistxjbz.toString(),
              state: 2
            }
            let loading = this.$loading()
            this.$patch(
              `/maintainPatrol/${this.formbzs.maintainPatrolToDos}`,
              params
            ).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$confirm(
                      this.$i18n.t('lang.lab_islist'),
                      this.$i18n.t('lang.lab_prompt'), {
                        confirmButtonText: this.$i18n.t('lang.btn_confirm'),
                        cancelButtonText: this.$i18n.t('lang.btn_cancel'),
                        type: 'warning'
                      }
                    )
                    .then(() => {
                      // 跳转报事页面
                      this.$router.push({
                        name: 'repoInfoBackgroundSupply',
                        query: {
                          parentId: this.id
                        }
                      })
                    })
                    .catch(() => {
                      this.$message.success(this.$i18n.t('lang.lab_paperefinsh'))
                      this.formbzs.maintainPatrolToDos = ''
                      this.maintains()
                      this.maintainLife()
                      this.maintainPatrols()
                      this.maintainPatrolPointLines()
                      this.maintainDevsices()
                      this.cleanPatrols()
                    })
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          }
        })
      },
      // 清空巡检设备信息
      cleandevide() {
        this.formsbs.maintainDeviceToDos = ''
        this.formsbs.infodevs = ''
        this.fileListsb = []
        this.fileslistsb = []
        setTimeout(() => {
          this.$refs.formsbs.clearValidate()
        }, 0)
      },
      // 完成巡检设备
      finishdevide(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            // 上传图片
            if (this.fileListsb.length > 0) {
              for (let i = 0; i < this.fileListsb.length; i++) {
                this.fileslistsb.push(this.fileListsb[i].url)
              }
            }

            let params = {
              info: this.formsbs.infodevs,
              files: this.fileslistsb.toString(),
              state: 1
            }
            let loading = this.$loading()
            this.$patch(
              `/maintainDevice/${this.formsbs.maintainDeviceToDos}`,
              params
            ).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_paperefinsh'))
                  this.maintains()
                  this.maintainLife()
                  this.maintainPatrols()
                  this.maintainPatrolPointLines()
                  this.maintainDevsices()
                  this.cleandevide()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          }
        })
      },
      // 异常巡检设备
      unfinishdevide(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            // 上传图片
            if (this.fileListsb.length > 0) {
              for (let i = 0; i < this.fileListsb.length; i++) {
                this.fileslistsb.push(this.fileListsb[i].url)
              }
            }
            let params = {
              info: this.formsbs.infodevs,
              files: this.fileslistsb.toString(),
              state: 2
            }
            let loading = this.$loading()
            this.$patch(
              `/maintainDevice/${this.formsbs.maintainDeviceToDos}`,
              params
            ).then(res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$confirm(
                    this.$i18n.t('lang.lab_islist'),
                    this.$i18n.t('lang.lab_prompt'), {
                      confirmButtonText: this.$i18n.t('lang.btn_confirm'),
                      cancelButtonText: this.$i18n.t('lang.btn_cancel'),
                      type: 'warning'
                    }
                  )
                  .then(() => {
                    // 跳转报事页面
                    this.$router.push({
                      name: 'repoInfoBackgroundSupply',
                      query: {
                        parentId: this.id
                      }
                    })
                  })
                  .catch(() => {
                    this.$message.success(this.$i18n.t('lang.lab_paperefinsh'))
                    this.maintains()
                    this.maintainLife()
                    this.maintainPatrols()
                    this.maintainPatrolPointLines()
                    this.maintainDevsices()
                    this.cleandevide()
                  })
              }
            })
          }
        })
      },
      // 清空巡检标准信息
      cleanPatrols() {
        this.formbzs.maintainPatrolToDos = ''
        this.formbzs.infos = ''
        this.fileListxjbz = []
        this.fileslistxjbz = []
        setTimeout(() => {
          this.$refs.formbzs.clearValidate()
        }, 0)
      },
      // 巡检标准
      maintainPatrols() {
        let loading = this.$loading()
        this.$get(
          `/maintainPatrol?maintainId=${this.id}&pageSize=${this.pageSize}&pageNo=${this.pageNum}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              // 巡检标准完成进度
              this.pageCount = res.pageCount
              this.maintainPatrol = res.maintainPatrol
              if (this.maintainPatrol.length > 0) {
                this.show = true
              } else {
                this.show = false
              }
              // 巡检标准下拉
              this.maintainPatrolToDo = res.maintainPatrolToDo
              if (this.maintainPatrolToDo.length > 0) {
                this.showToDo = true
              } else {
                this.showToDo = false
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 巡检线路完成进度
      maintainPatrolPointLines() {
        let loading = this.$loading()
        this.$get(`/maintainPatrolPointLine?maintainId=${this.id}`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              // this.maintainPatrolPointLineToDo = res.maintainPatrolPointLineToDo
              this.maintainPatrolPointLine = res.maintainPatrolPointLine
              if (this.maintainPatrolPointLine.length > 0) {
                this.showPL = true
                var mppl = this.maintainPatrolPointLine
                var fenzi = 0
                for (var int = 0; int < mppl.length; int++) {
                  if (mppl[int].state != 0) {
                    fenzi++
                  }
                }
                this.jindu = fenzi + '/' + mppl.length
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 巡检设备完成进度
      maintainDevsices() {
        let loading = this.$loading()
        this.$get(`/maintainDevice?maintainId=${this.id}`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.maintainDeviceToDo = res.maintainDeviceToDo
              this.maintainDevice = res.maintainDevice
              if (this.maintainDevice.length > 0) {
                this.showDevice = true
              } else {
                this.showDevice = false
              }
              if (this.maintainDeviceToDo.length > 0) {
                this.showToDoDevice = true
              } else {
                this.showToDoDevice = false
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 审阅工单保存
      syonSubmit() {
        // 上传图片
        if (this.fileListsy.length > 0) {
          for (let i = 0; i < this.fileListsy.length; i++) {
            this.fileslistsy.push(this.fileListsy[i].url)
          }
        }
        let params = {
          isCheck: this.formsy.isCheck,
          content: this.formsy.readtext,
          files: this.fileslistsy.toString()
        }

        let loading = this.$loading()
        this.$patch(`/maintains/${this.id}/check`, params).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.$message.success(this.$i18n.t('lang.lab_save_success'))
              this.jump()
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 转移工单保存
      zyonSubmit(formName) {
        if (this.form.isRequireDigitalSignature == 1) {
          this.$message.info('需要在app端进行手写签名')
          return
        }
        this.$refs[formName].validate(valid => {
          if (valid) {
            let params = {
              content: this.formzy.readtext,
              isDisplay: 1,
              staff: this.formzy.changeto,
              maintainTypeId1: this.form.maintainTypeId1,
              maintainTypeId2: this.form.maintainTypeId2,
              maintainTypeId3: this.form.maintainTypeId3
            }

            let loading = this.$loading()
            this.$patch(`/maintains/${this.id}/cancel`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.jump()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          }
        })
      },
      // 回访工单
      hfonSubmit(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            // 上传图片
            if (this.fileListhf.length > 0) {
              for (let i = 0; i < this.fileListhf.length; i++) {
                this.fileslisthf.push(this.fileListhf[i].url)
              }
            }
            // 上传图片
            if (this.fileListhffj.length > 0) {
              for (let i = 0; i < this.fileListhffj.length; i++) {
                this.fileslisthffj.push(this.fileListhffj[i].url)
              }
            }
            let params = {
              content: this.formhf.readtext,
              type: 11,
              isDisplay: 1,
              image: this.fileslisthf.toString(),
              withFile: this.fileslisthffj.toString()
            }
            let loading = this.$loading()
            this.$patch(`/maintains/${this.id}/follow`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.jump()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          }
        })
      },
      // 跟进工单
      gjonSubmit(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            // 上传图片
            if (this.fileListgj.length > 0) {
              for (let i = 0; i < this.fileListgj.length; i++) {
                this.fileslistgj.push(this.fileListgj[i].url)
              }
            }
            // 上传图片
            if (this.fileListgjfj.length > 0) {
              for (let i = 0; i < this.fileListgjfj.length; i++) {
                this.fileslistgjfj.push(this.fileListgjfj[i].url)
              }
            }
            let params = {
              content: this.formgj.readtext,
              type: 10,
              isDisplay: 1,
              image: this.fileslistgj.toString(),
              withFile: this.fileslistgjfj.toString()
            }
            let loading = this.$loading()
            this.$patch(`/maintains/${this.id}/follow`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.jump()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          }
        })
      },
      // 延时工单保存
      ysonSubmit() {
        // 上传图片
        if (this.fileListys.length > 0) {
          for (let i = 0; i < this.fileListys.length; i++) {
            this.fileslistys.push(this.fileListys[i].url)
          }
        }
        let params = {
          normal: 1,
          isDisplay: 1,
          image: this.fileslistys.toString(),
          content: this.ysreadtext
        }
        let loading = this.$loading()

        this.$patch(`/maintains/${this.id}/normal`, params).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.$message.success(this.$i18n.t('lang.lab_save_success'))
              this.jump()
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 接单保存
      orderreceiving(formjd) {
        this.$refs[formjd].validate(valid => {
          if (valid) {
            let params = {
              id: this.id,
              type: 2,
              source: 1,
              content: this.Conlistname,
              maintainTypeId1: this.formjd.maintainTypeId1,
              maintainTypeId2: this.formjd.maintainTypeId2,
              maintainTypeId3: this.formjd.maintainTypeId3,
              result: 1, // flsg需要对应
              isOvertime: this.form.isOvertime
            }
            let loading = this.$loading()

            this.$patch(`/maintains/${this.id}/result`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_received_orde'))
                  this.maintains()
                  this.maintainLife()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          }
        })
      },
      // 派单保存
      preceiving(formpd) {
        this.$refs[formpd].validate(valid => {
          if (valid) {
            let params = {
              id: this.id,
              type: 7,
              source: 1,
              content: this.sendcontent,
              staffid: this.formpd.peopleid.split(',')[1],
              staffname: this.formpd.peopleid.split(',')[0],
              maintainTypeId1: this.formpd.maintainTypeId1,
              maintainTypeId2: this.formpd.maintainTypeId2,
              maintainTypeId3: this.formpd.maintainTypeId3,
              isOvertime: this.form.isOvertime
            }
            let loading = this.$loading()
            this.$patch(`/maintains/${this.id}/dispatch`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_dispatch_orde'))
                  this.maintains()
                  this.maintainLife()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          }
        })
      },
      // 监听关闭dialog延时工单
      yshandleDialogClosed() {
        this.ysreadtext = ''
        this.fileListys = []
      },
      // 监听关闭dialog转移工单
      zyhandleDialogClosed() {
        this.formzy.readtext = ''
        this.formzy.changeto = ''
        setTimeout(() => {
          this.$refs.formzy.clearValidate()
        }, 0)
      },
      // 监听关闭dialog审阅工单
      syhandleDialogClosed() {
        if (this.formsy.readtext) {
          this.formsy.readtext = ''
        }
        this.formsy.isCheck = 1
        this.fileListsy = []
      },
      // 监听关闭dialog跟进工单
      gjhandleDialogClosed() {
        this.fileListgj = [] // 图片列表清空
        this.fileListgjfj = [] // 附件列表清空
        this.formgj.readtext = ''
        this.$refs.formgj.clearValidate()
      },
      // 监听关闭dialog回访工单
      hfhandleDialogClosed() {
        this.fileListhf = [] // 图片列表清空
        this.fileListhffj = [] // 附件列表清空
        this.formhf.readtext = ''
        this.$refs.formhf.clearValidate()
      },
      // 监听关闭dialog变更报事类型
      bghandleDialogClosed() {
        this.maintains()
        this.formbg.readtext = ''
        this.$refs.formbg.clearValidate()
      },
      // 监听关闭dialog关闭工单
      gbhandleDialogClosed() {
        this.formgb.desc = ''
        this.formgb.isNormalClose = 1
        this.$refs.formgb.clearValidate()
      },
      // 变更报事保存
      saveupdateTypeMaintains(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            let params = {
              maintainTypeId1: this.formbg.maintainTypeId1,
              maintainTypeId2: this.formbg.maintainTypeId2,
              maintainTypeId3: this.formbg.maintainTypeId3,
              content: this.formbg.readtext
            }
            let loading = this.$loading()
            this.$patch(`/maintains/${this.id}/updateTypeMaintains`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.showupdate = false
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.jump()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          }
        })
      },
      // 关闭工单
      gbonSubmit(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            let params = {
              content: this.formgb.desc,
              isDisplay: this.formgb.isNormalClose == 2 ? 0 : 1,
              isNormalClose: this.formgb.isNormalClose
            }
            let loading = this.$loading()
            this.$patch(`/maintains/${this.id}/close`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.showgd = false
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.maintains()
                  this.maintainLife()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          }
        })
      },
      // 评价保存
      appraise() {
        this.$confirm(this.$i18n.t('lang.lab_isSaveFee'),
            this.$i18n.t('lang.lab_prompt'), {
              confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              type: 'warning'
            })
          .then(() => {
                    // 待评价上传图片
              if (this.fileListdpj.length > 0) {
                for (let i = 0; i < this.fileListdpj.length; i++) {
                  this.fileslistdpj.push(this.fileListdpj[i].url)
                }
              }
              let params = {
                id: this.id,
                evaluation: this.forms.contents,
                files: this.fileslistdpj.toString(),
                evaluate: this.grade,
                isDisplay: this.forms.yzshow,
                twoEvaluationList: this.gradeconlist
              }
              let loading = this.$loading()
              this.$patch(`/maintains/${this.id}/evaluate`, params).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_comment_successful'))
                    this.maintains()
                    this.maintainLife()
                    this.getEvaluationDetailByGrade()
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )  
          })
      },
      // 待处理工单保存
      finish() {
         this.$confirm(this.$i18n.t('lang.lab_isSaveFee'),
            this.$i18n.t('lang.lab_prompt'), {
              confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              type: 'warning'
            })
          .then(() => {
          if (this.userDataid == this.form.endPerson || !this.form.endPerson) {
          if (this.form.isRequireDigitalSignature == 1) {
             this.$message.info('需要在app端进行手写签名')
             return
          }
          // 上传图片
          if (this.fileList.length > 0) {
            for (let i = 0; i < this.fileList.length; i++) {
              this.fileslist.push(this.fileList[i].url)
            }
          }
          // 上传附件
          if (this.fileListfj.length > 0) {
            for (let j = 0; j < this.fileListfj.length; j++) {
              this.withFileslist.push(this.fileListfj[j].url)
            }
          }
          let params = {
            id: this.id,
            staffid: this.form.staffId,
            source: 1,
            type: 3,
            evaluate: this.form.evaluate,
            files: this.fileslist.toString(),
            content: this.formpj.contents,
            withFiles: this.withFileslist.toString(),
            difficulty: this.formpj.difficulty
          }
          let loading = this.$loading()
          this.$patch(`/maintains/${this.id}/worker`, params).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message.success(this.$i18n.t('lang.btn_finish'))
                this.maintains()
                this.maintainLife()
                this.getEvaluationDetailByGrade()
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        } else {
          this.$message.error('该工单已设置封单人，请将当前完成工作内容通过【跟进工单】进行描述，然后转单给【' + this.form.endPersonInfo.idNo + '】进行封单')
        }
      })
      },
      // 待评论查询评语list
      getEvaluationDetailByGrade() {
        let loading = this.$loading()
        this.$get(
          `/getEvaluationDetailByGrade?grade=${this.grade}&diaPlay=false&pageNo=1&pageSize=999`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.orderlist = res.list
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 隔行变色
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 查询工单详情
      maintains() {
        let loading = this.$loading()
        this.$get(`/maintains/${this.id}`).then(
          res => {
            loading.close()
            if (res) {
              console.log(res)
              this.form = res
              let copyToStaffArr = res.maintainCopyToStaff.map(function (item) {
                return item.idNo
              })
              this.form.maintainCopyToStaff = copyToStaffArr.join('，')
              if (this.form.maintainTypeId1) {
                // 变更报事类型用
                this.formbg.maintainTypeId1 = this.form.maintainTypeId1
                if (this.formbg.maintainTypeId1) {
                  this.levalmaintainTypes(this.formbg.maintainTypeId1, 'type')
                }
                this.formpd.maintainTypeId1 = this.form.maintainTypeId1
                if (this.formpd.maintainTypeId1) {
                  this.levalmaintainTypes(this.formpd.maintainTypeId1, 'typepd')
                }
                this.formjd.maintainTypeId1 = this.form.maintainTypeId1
                if (this.formjd.maintainTypeId1) {
                  this.levalmaintainTypes(this.formjd.maintainTypeId1, 'typejd')
                }
              }
              if (this.form.maintainTypeId2) {
                // 变更报事类型用
                this.formbg.maintainTypeId2 = this.form.maintainTypeId2
                if (this.formbg.maintainTypeId2) {
                  this.levalmaintainTypes3(this.formbg.maintainTypeId2, 'type')
                }
                this.formpd.maintainTypeId2 = this.form.maintainTypeId2
                if (this.formpd.maintainTypeId2) {
                  this.levalmaintainTypes3(this.formpd.maintainTypeId2, 'typepd')
                }
                this.formjd.maintainTypeId2 = this.form.maintainTypeId2
                if (this.formjd.maintainTypeId2) {
                  this.levalmaintainTypes3(this.formjd.maintainTypeId2, 'typejd')
                }
              }
              if (this.form.maintainTypeId3) {
                // 变更报事类型用
                this.formbg.maintainTypeId3 = this.form.maintainTypeId3
                this.formpd.maintainTypeId3 = this.form.maintainTypeId3
                this.formjd.maintainTypeId3 = this.form.maintainTypeId3
              }
              if (this.form.garden.id) {
                this.staffs(this.form.garden.id)
              }
              if (this.form.state === 3) {
                this.getEvaluationDetailByGrade()
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 查询工单一生
      maintainLife() {
        let loading = this.$loading()
        this.$get(`/maintainLife/${this.id}`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              if (res.list.length > 0) {
                this.tableData = res.list
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 通过一级别查询二级下拉list
      selectSecond(value) {
        this.levalmaintainTypes(value, 'type')
        this.formbg.maintainTypeId2 = ''
        this.formbg.maintainTypeId3 = 0
        this.thirdLevellist = []
      },
      selectSecondjd(value) {
        this.levalmaintainTypes(value, 'typejd')
        this.formjd.maintainTypeId2 = ''
        this.formjd.maintainTypeId3 = 0
        this.thirdLevellistjd = []
      },
      selectSecondpd(value) {
        this.levalmaintainTypes(value, 'typepd')
        this.formpd.maintainTypeId2 = ''
        this.formpd.maintainTypeId3 = 0
        this.thirdLevellistpd = []
      },
      // 通过二级别查询三级下拉list
      selectThird(value) {
        this.levalmaintainTypes3(value, 'type')
        this.formbg.maintainTypeId3 = 0
      },
      selectThirdjd(value) {
        this.levalmaintainTypes3(value, 'typejd')
        this.formjd.maintainTypeId3 = 0
      },
      selectThirdpd(value) {
        this.levalmaintainTypes3(value, 'typepd')
        this.formpd.maintainTypeId3 = 0
      },
      // 报事服务分类list
      maintainTypes() {
        this.$get(
          `/maintainTypes?type=${this.typeleval}&pageSize=999&pageNo=1&parentId=${this.gardenId}`
        ).then(
          res => {
            if (res && res.errCode === 0) {
              if (this.typeleval === 1) {
                this.firstLevellist = res.list
              }
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 通过级别id查询下一级别list
      levalmaintainTypes(Pid, typeleval) {
        this.$get(`/maintainTypes?type=2&pageSize=999&pageNo=1&Pid=${Pid}`).then(
          res => {
            if (res && res.errCode === 0) {
              if (typeleval === 'type') {
                this.secondLevellist = res.list
              } else if (typeleval === 'typejd') {
                this.secondLevellistjd = res.list
              } else {
                this.secondLevellistpd = res.list
              }
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 2级id查询三级list
      levalmaintainTypes3(Pid, typeleval) {
        this.$get(`/maintainTypes?type=3&pageSize=999&pageNo=1&Pid=${Pid}`).then(
          res => {
            if (res && res.errCode === 0) {
              if (typeleval === 'type') {
                this.thirdLevellist = res.list
              } else if (typeleval === 'typejd') {
                this.thirdLevellistjd = res.list
              } else {
                this.thirdLevellistpd = res.list
              }
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 分派人员下拉
      staffs(gardenIds) {
        let loading = this.$loading()
        this.$get(`/staffs?pageSize=999&pageNo=1&gardenId=${gardenIds}`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.peoplelist = res.list
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 返回list页面
      jump() {
          this.$router.push({
            name: 'questionOrder'
          })
      },
      // 打印工单
      print() {
        let routeData = this.$router.resolve({
          name: 'print400List'
        })
        localStorage.setItem('form', JSON.stringify(this.form))
        window.open(routeData.href, '_blank')
      },
      // 处理工单
      collapseOne() {
        this.$refs.formjd.clearValidate()
        if (this.jdshow === true) {
          this.jdshow = false
        } else {
          this.pdshow = false
          this.jdshow = true
        }
      },
      // 强制派单
      collapseTwo() {
        this.$refs.formpd.clearValidate()
        if (this.pdshow === true) {
          this.pdshow = false
        } else {
          this.jdshow = false
          this.pdshow = true
        }
      },
      // 变更报事类型
      updateTypeMaintains() {
        this.showupdate = true
      },
      // 转移工单
      cancelMaintains() {
        let loading = this.$loading()
        this.$get(
          `/staffs?pageSize=999&pageNo=1&gardenId=${this.form.garden.id}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.showzy = true
              this.changetolist = res.list
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      csjl() {
        this.$router.push({ name: 'trialDetailList1', query: { id: this.id } })
      },
      // 延时工单
      normalMaintains() {
        this.showys = true
      },
      // 跟进工单
      followMaintains() {
        this.showgj = true
      },
      // 回访工单
      followMaintainsres() {
        this.showhf = true
      },
      // 审阅工单
      checkMaintains() {
        this.showsy = true
      },
      // 关闭工单
      closeMaintain() {
        this.showgd = true
      },
      // 下载附件
      handlePreview(file) {
        console.log(file)
        let uri = file.split('|')[0]
        let name = file.split('|')[1]
        var url = 'http://' + window.location.host + '/mapi/'
        if (file.response) {
          window.open(url + `downloadFileByRealName?downloadUrl=` + uri + `&realFileName=` + name)
        } else {
          if (uri.indexOf('blob:') == -1) {
            window.open(url + `downloadFileByRealName?downloadUrl=` + uri + `&realFileName=` + name)
          }
        }
      },
      // pdf打印
      pdfPrint() {
        this.$router.push({
            name: 'pdfPrint',
            query: {
              id: this.id
            }
          })
      },
      // 获取审阅工单权限
      getStaffReview() {
        this.$get(`/staffs/${this.userDataid}`).then(
          res => {
            if (res && res.errCode === 0) {
              console.log(res)
              this.review = res.review
            }
          },
          error => {
            this.$message.error(error)
          })
      },
      // 查看子工单
      viewChildWorkOrder() {
        sessionStorage.setItem('haveChildParentId', this.id)
        this.$router.push({
          name: 'fullprojectAutoInspecRepoList',
        })
      }
    }
  }
</script>

<style lang="scss">
  .backgroundDetail .matop {
    margin-top: 30px;
  }

  .backgroundDetail .btn_orange {
    background: #f07157;
    color: #ffffff;
  }

  .backgroundDetail .el-col-12 {
    // height: 40px;
  }

  .backgroundDetail .el-col-6 {
    // height: 40px;
  }

  .backgroundDetail .el-col-8 {
    // height: 40px;
  }

  .backgroundDetail .el-col-24 {
    // height: 40px;
  }

  .backgroundDetail .wid80 {
    width: 80%;
  }

  .backgroundDetail .img {
    width: 40px;
    height: 24px;
    border: 1px solid lightgray;
    border-radius: 5px;
    padding: 5px;
    margin-right: 20px;
  }

  .backgroundDetail .btnmar {
    margin-right: 20px;
    color: #0000ee;
  }

  .backgroundDetail .el-table th {
    padding: 0px;
  }

  .backgroundDetail .mat-22 {
    margin-top: 22px;
  }

  .backgroundDetail .custom .el-select .el-input__inner {
    width: 400px;
  }

  .backgroundDetail .normals {
    font-style: normal;
  }

  .backgroundDetail .pad-lef20 {
    padding-left: 20px;
  }

  .backgroundDetail .positionPoint {
    position: absolute;
  }

  .backgroundDetail .height_all {
    height: 100px;
  }

  .backgroundDetail .pointSpan {
    position: absolute;
    color: #f00;
    width: 150px;
    height: 50px;

    span {
      font-weight: 900;
      font-size: 150%;
      color: #f00;
    }
  }

  .backgroundDetail .getImg {
    width: 700px;
    height: auto;
  }

  .backgroundDetail .pointImg {
    position: absolute;
    margin-left: -25px;
    margin-top: -40px;
    width: 40px;
    height: 50px;
    display: block;
  }

  .backgroundDetail .input {
    width: 60vw !important;
  }

  .el-tooltip__popper.is-light {
    max-width: 300px;
  }

  .backgroundDetail .replyCon {
    width: 400px;
  }

  // 解决多选框长度过长显示异常问题
  .backgroundDetail {
    .chooseActive {
      label {
        .el-checkbox__label {
          max-width: 155px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          vertical-align: middle; // 纵向居中
        }
      }
    }
  }

  .detailPosition {
    position: absolute !important;
  }
</style>